function auto_play() {
	if(jQuery(".AudioPlay").length > 0){
		jQuery(".AudioPlay").click(function(){
			if(jQuery.cookie("was_playing") && jQuery.cookie("was_playing") == "true"){
				jQuery.cookie("was_playing","false",{"path":"/"})
			}else{
				jQuery.cookie("was_playing","true",{"path":"/"});
			}
			
		});
		
		if(jQuery.cookie("was_playing") && jQuery.cookie("was_playing") == "true"){
			jQuery(".AudioPlay").click();
			jQuery.cookie("was_playing","true",{"path":"/"})
		}
	}else{
		setTimeout(auto_play,200);
	}
}
jQuery(auto_play);
